import { render, staticRenderFns } from "./PodtEditCutChild.vue?vue&type=template&id=84128ad0&"
import script from "./PodtEditCutChild.vue?vue&type=script&lang=js&"
export * from "./PodtEditCutChild.vue?vue&type=script&lang=js&"
import style0 from "./PodtEditCutChild.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports